export var getIds = id => id ? {
  root: id,
  iconWrapper: "".concat(id, "__icon-wrapper"),
  loader: "".concat(id, "__loader"),
  text: "".concat(id, "__text")
} : undefined;
//# sourceMappingURL=getIds.js.map